import type { CommonApp, ElibooApp } from "@eliboo/api-models";
import type { CommonHttpOptions } from "@eliboo/api/common";

import { useGetApi } from "@eliboo/api/common";

import { useApiOptions } from "../api-options";

export function useGetChannelOperatorConfig(defaultOptions: CommonHttpOptions = useApiOptions({}, true)) {
  const url = `/eliboo-app-boot/app-api/v1/channelOperatorConfig/getByChannelOperatorDir`;
  return useGetApi<never, ElibooApp.ChannelOperatorConfigDTO>(url, defaultOptions);
}
